import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { fileUploadPolicyFor, validateFileUploadSize } from '@/utils/file-upload-policy'

export const useFileUploadPolicy = () => {
  const currentUser = useSelector((state) => state.user.current)
  const policy = useMemo(() => fileUploadPolicyFor(currentUser), [currentUser])

  return {
    ...policy,
    validateFileSize: (file) => validateFileUploadSize(file, policy)
  }
}
